<template>
  <div>
    <v-row justify="center">
      <v-dialog
        v-model="showDialog"
        persistent
        scrollable
        max-width="700"
      >
        <v-card>
          <v-card-title class="text-h5">
            {{errors.error}}
          </v-card-title>
          <v-card-text>
            <ul>
              <li v-for="(error, idx) in errors.errors" :key="idx" >
                <div class="text-error">Detalle: {{ error.description }}</div>
                <ul>
                  <li v-for="(e, i) in error.errors" :key="i">
                    <div class="text-error">Mensaje: </div> 
                    {{e.message_error}}
                    <div class="text-error">Descripción: </div> 
                    Para {{e.rule_col}} con valor {{e.rule_value}} se encontraron los siguientes valor(es) en {{e.error_col}}:
                    <br>
                    <ol>
                      <li v-for="(ev, iv) in e.error_value" :key="iv">
                        {{ev}}
                      </li>
                    </ol>
                  </li>
                </ul>
              </li>
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              outlined
              @click="closeDialogError"
              :disabled="loading"
            >
              Cerrar
            </v-btn>
            <!-- <v-btn
              color="blue darken-1"
              outlined
              @click="downloadFile"
              :loading="loading"
              :disabled="loading"
            >
              Descargar
            </v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
// import uris from '../../../utils/uris'
// import axios from '../../../utils/axiosWrapperAutoservicio'
import eventBus from '../../../utils/eventBus'

export default {
  name: 'validation-dialog-error',
  data () {
    return {
      loading: false,
      showDialog: false,
      errors: {},
      file: []
    }
  },
  created () {
    eventBus.$off('open-dialog-insert-data-error')
    eventBus.$on('open-dialog-insert-data-error', (data) => {
      this.openDialogError(data.showDialog, data.errors, data.file)
    })
  },
  methods: {
    openDialogError (showDialog, errors, file) {
      this.showDialog = showDialog
      this.errors = errors
      this.file = file
    },
    closeDialogError () {
      this.showDialog = false
    },
    downloadFile () {
      // this.loading = true
      // let formData = new FormData()
      // formData.append('excel_file', this.file)
      // formData.append('data', JSON.stringify(this.errors))

      // console.log(formData)
      // axios.post(uris.URL_AUTOSERVICIO_GET_ERROR_TEMPLATE,
      //   formData
      //   , {
      //     responseType: 'blob'
      //   })
      //   .then((response) => {
      //     const filename = response.headers.filename
      //     const url = window.URL.createObjectURL(new Blob([response.data]))
      //     const link = document.createElement('a')
      //     link.href = url
      //     link.setAttribute('download', filename)
      //     document.body.appendChild(link)
      //     link.click()
      //     link.remove()
      //   })
      //   .catch((err) => {
      //     console.warn('No se ha podido obtener data de errores', err)
      //   })
      //   .finally(() => {
      //     this.loading = false
      //   })
    }
  }
}
</script>

<style>
.text-error {
  color: black;
}

</style>


// WEBPACK FOOTER //
// src/components/autoservicios/validation/validation-insert-data-dialog-error.vue